<script setup>
import { useRouter } from 'vue-router'
import { isUserLoggedIn } from '@/router/utils'

const router = useRouter()
router.replace(isUserLoggedIn() ? '/discover' : '/home')
</script>

<template>
  <div />
</template>

<route lang="yaml">
meta:
  layout: blank
  allowLoggedInOnly: false
</route>
